import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'

type Props = {
    children: ReactNode
}

/**
 * ShipCardをchildrenとして受け取り、SPでは縦にPCでは横に並べるコンポーネント
 */
export const ShipCardLayout: React.VFC<Props> = ({
        children
    }) => {
        return <Wrapper>{children}</Wrapper>
}

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    row-gap: ${Styles.spacing[11]};
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        grid-template-columns: 1fr;
        column-gap: ${Styles.spacing[10]};
    }
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        grid-template-columns: repeat(2, 1fr);
        column-gap: ${Styles.spacing[10]};
        row-gap: ${Styles.spacing[11]};
    }
`
